import classNames from "classnames";
import { Button } from "PFComponents/button";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import css from "./toast.less";

const ToastWrap = ({ kind, action, actionText, text, show, iconAction, icon }) => {
  show = show && (text || action);

  const [intro, setIntro] = useState(false);

  useEffect(() => {
    setIntro(true);
    const timeoutId = window.setTimeout(() => setIntro(false), 125);
    return () => window.clearTimeout(timeoutId);
  }, [actionText, text, show]);

  const style = kind === "toast" ? { height: document.body.clientHeight } : null;

  const isHidden = !show;

  if (!document.getElementById("modal_region")) {
    return null;
  }

  return ReactDOM.createPortal(
    <div style={style} className={classNames(css.root, { [css[kind]]: true })}>
      <div className={classNames(css.wrap, { [css.intro]: intro, [css.hide]: isHidden })}>
        <div className={css.box}>
          <span className={action || iconAction ? css.text : css.loneText}>{text}</span>
          {iconAction && icon && (
            <Button small onClick={iconAction} kind="blank">
              {icon}
            </Button>
          )}
          {action && actionText && <Button onClick={action}>{actionText}</Button>}
        </div>
      </div>
    </div>,
    document.getElementById("modal_region")
  );
};

ToastWrap.propTypes = {
  kind: PropTypes.oneOf(["snackbar", "toast"]),
  text: PropTypes.string,

  action: PropTypes.func,
  actionText: PropTypes.string,

  iconAction: PropTypes.func,
  icon: PropTypes.node,

  show: PropTypes.bool
};

ToastWrap.defaultProps = {
  kind: "toast",
  show: true,
  text: ""
};

export default ToastWrap;
